import React from "react";
import log from "loglevel";
import {RoutePlanningProvider} from "../providers/RoutePlanningProvider";
import RoutePlanningView from "./RoutePlanningView";
import DispatchRulesDataProvider from "../providers/DispatchRulesDataProvider";
import {JobTypes} from "../components/settings/ColorSettings/ColorizedIndicators/types/jobTypeSelectorValues";
import {useFeatureFlagContext} from "../providers/FeatureFlagProvider";
import {Redirect} from "react-router-dom";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";

const RoutePlanningViewContainer = () => {
  const {routePlanning: routePlanningEnabled, featureFlagsInitialized} = useFeatureFlagContext();

  if (featureFlagsInitialized && !routePlanningEnabled) {
    log.debug("Route Planning feature flag is disabled, redirecting to jobs view.");
    return <Redirect to="/jobs" />;
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <RoutePlanningProvider>
        <DispatchRulesDataProvider jobType={JobTypes.UnassignedJobs}>
          <RoutePlanningView />
        </DispatchRulesDataProvider>
      </RoutePlanningProvider>
    </LocalizationProvider>
  );
};

export default RoutePlanningViewContainer;
